import { Component, OnInit, SecurityContext } from '@angular/core'
import { CmsService } from '@spartacus/core'
import { DomSanitizer } from '@angular/platform-browser'

@Component({
  standalone: false,

  selector: 'vs-register-section',
  templateUrl: './register-section.component.html',
  styleUrls: ['./register-section.component.scss'],
})
export class RegisterSectionComponent implements OnInit {
  registrationLink = ''
  constructor(
    private cmsService: CmsService,
    private domSanitizer: DomSanitizer
  ) {}

  ngOnInit(): void {
    this.cmsService
      .getComponentData('RegistrationLink')
      .subscribe((res: any) => {
        this.registrationLink = res.url
      })
  }

  onRegisterClick() {
    window.location.href = this.domSanitizer.sanitize(
      SecurityContext.URL,
      this.registrationLink
    )
  }
}
